export default __webpack_public_path__ + "static/media/meal-heavy-black.cfd58937.svg";